import React from 'react';
import {GridColDef, GridRenderEditCellParams, useGridApiContext} from '@mui/x-data-grid-pro';
import {Stack} from '@mui/material';

import {ColumnProps} from '@utils/table/columnTypes.table';
import {Array} from '@utils/extensions/array.extension';
import DatePickerComponent from '@components/inputs/datePicker/DatePicker.component';

type DateColumnComponentProps = GridRenderEditCellParams

const DateColumnComponent = (props: DateColumnComponentProps) => {
  const {id, field, value} = props;

  const apiRef = useGridApiContext();

  return (
    <Stack flex={1}>
      <DatePickerComponent
        hasFocus={props.hasFocus}
        placeholder="-"
        handleChange={(newValue) => apiRef.current.setEditCellValue({id, field, value: newValue})}
        value={value}/>
    </Stack>
  );
};

interface DateColumnProps extends ColumnProps {
  disabled?: boolean;
  hideInput?: (row: any) => boolean;
}

export const COLUMN_TYPE_DATE = (props: DateColumnProps): GridColDef => ({
  cellClassName: (params) => Array.mapNotNull([props.cellClassName?.(params)])?.join(' ') ?? '',
  field: props.field ?? '',
  headerName: props.label,
  minWidth: props.minWidth ?? 50,
  sortable: props.sortable ?? false,
  editable: !props.disabled,
  renderCell: (params) => {
    if (props.hideInput?.(params.row)) {
      return params.formattedValue;
    }
    return (
      <Stack flex={1}>
        <DatePickerComponent
          readOnly
          placeholder="-"
          value={params.value}/>
      </Stack>
    );
  },
  renderEditCell: (params) => {
    if (props.hideInput?.(params.row)) {
      return params.formattedValue;
    }
    return (
      <DateColumnComponent {...params}/>
    );
  },
  valueGetter: props.valueGetter,
  valueFormatter: props.valueFormatter,
  width: props.width ?? 150,
});
